export enum FeatureApiType {
    ACH = 'ACH',
    AccountRecon = 'AccountRecon',
    BillPay = 'BillPayProductFeature',
    ElectronicDocuments = 'ElectronicDocumentsProductFeature',
    PositivePay = 'ArpProductFeature',
    RemoteDeposit = 'RemoteDepositCaptureSsoProductFeature',
    Reporting = 'InformationReportingProductFeature',
    StopPayment = 'StopPayment',
    Transfer = 'InternalTransferProduct',
    Wire = 'WireTransferProductFeature',

    AmpliFiLoyalty = 'AmpliFiLoyalty',
    CentrixSso = 'CentrixSso',
    Agiletics = 'AgileticsSso',
    ForeignCurrencyWire = 'WireTransferDliProductFeature',
    Wausau = 'WausauStatements',
}

export enum FiFeatureApiType {
    ACH = 'FiAchProductFeature',
    AccountRecon = 'FiAccountReconProductFeature',
    BillPay = 'BillPay',
    ElectronicDocuments = 'ElectronicDocuments',
    PositivePay = 'ARP',
    RemoteDeposit = 'RemoteDeposits',
    Reporting = 'FiInformationReportingProductFeature',
    StopPayment = 'StopPayment',
    Transfer = 'FiInternalTransferProductFeature',
    Wire = 'FiWireTransferProductFeature',

    Agiletics = 'AgileticsSso',
    AmpliFiLoyalty = 'AmpliFiLoyalty',
    CentrixSso = 'CentrixSso',
    ForeignCurrencyWire = 'FiWireTransferDliProductFeature',
    Wausau = 'WausauStatements',
}

export const ToastEntityLabel = {
    StopPayment: 'stop payment',
    AccountRecon: 'reporting',
    Transfer: 'transfers',
    Reporting: 'reporting',
};
